import { Route } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseCardModule } from '@fuse/components/card';
import { FuseAlertModule } from '@fuse/components/alert';
import { SharedModule } from 'app/shared/shared.module';
import { DirectivesModule } from 'app/directives/directive.module';
import { FormulasComponent } from './formulas.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatCustomTableModule } from 'app/components/mat-custom-table/mat-custom-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaskModule, IConfig } from 'ngx-mask';

export const routes: Route[] = [
    {
        path: '',
        component: FormulasComponent,
    },
];
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    declarations: [FormulasComponent],
    imports: [
        RouterModule.forChild(routes),
        MatIconModule,
        CommonModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        SharedModule,
        FuseCardModule,
        FuseAlertModule,
        DirectivesModule,
        MatSelectModule,
        MatTableModule,
        MatCustomTableModule,
		MatSortModule,
		MatPaginatorModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        NgxMaskModule.forRoot(),
    ],
})
export class FormulasModule {}
